export const getTreeDataPath = (row) => row.sectionPath